import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { buildFolderNavigationSharedFlags } from 'utils/fileManagerSharedFolderUtils';

export const useFileNavigation = ({ userContext }) => {
  const history = useHistory();
  const location = useLocation();
  const { handleBreadCrumbs, onFilterChange, fileManagerFilters } = useFileManagerContext();

  const setQuery = useCallback(
    (data) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set('file_id', data?.object_id);
      history.push({ pathname: location.pathname, search: searchParams.toString() });
    },
    [history, location.pathname]
  );

  const selectFile = useCallback(
    (e) => {
      if (e?.entry_type !== 'folder') {
        setQuery(e);
        return;
      }

      const isSharedFolder = e?.folder_shared === true;
      const isClientUser = userContext?.access_level === 'client';
      const hasFolderId = e?.object_id && e?.object_id !== '' && e?.object_id !== 'undefined';
      const isCurrentlyInSharedMode = fileManagerFilters?.shared_folder === true;
      const shouldSetSharedFolder = isClientUser && hasFolderId && (isCurrentlyInSharedMode || isSharedFolder);
      const sharedFlags = buildFolderNavigationSharedFlags({ entry: e, fileManagerFilters });

      handleBreadCrumbs({
        ...e,
        folder_shared: isSharedFolder || fileManagerFilters?.folder_shared === true,
      });

      onFilterChange({
        target: { name: 'selectedFolder' },
        value: e?.object_id,
        ...(shouldSetSharedFolder ? { shared_folder: true } : isCurrentlyInSharedMode ? { shared_folder: true } : {}),
        ...sharedFlags,
        folder_type: e?.folder_type,
        is_virtual: e?.is_virtual,
        is_system_folder: e?.is_system_folder,
      });
    },
    [fileManagerFilters, userContext, handleBreadCrumbs, onFilterChange, setQuery]
  );

  return { setQuery, selectFile };
};
